import { Link } from "react-router-dom";
import { useTranslations } from "next-intl";

type CourseNavLinksProps = {
  tenantSlug: string;
  courseSlug: string;
  active?: "community" | "announcements";
};

/** COMM-3: links between a course's Community and Announcements pages (and the player header). */
export function CourseNavLinks({ tenantSlug, courseSlug, active }: CourseNavLinksProps) {
  const t = useTranslations("announcements");
  const base = `/t/${tenantSlug}/learn/${courseSlug}`;
  const links = [
    { key: "community" as const, to: `${base}/community`, label: t("navCommunity") },
    { key: "announcements" as const, to: `${base}/announcements`, label: t("navAnnouncements") },
  ];
  return (
    <nav aria-label={t("navLabel")} className="flex flex-wrap gap-4 text-sm">
      {links.map((link) => (
        <Link
          key={link.key}
          to={link.to}
          aria-current={active === link.key ? "page" : undefined}
          className={
            active === link.key
              ? "font-semibold text-[var(--text-heading)] underline"
              : "text-[var(--text-heading)] hover:underline"
          }
          data-testid={`course-nav-${link.key}`}
        >
          {link.label}
        </Link>
      ))}
    </nav>
  );
}
